import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

// components
import AppCard from 'src/components/AppCard.js'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppFirstDetails from 'src/components/details/brand-details/AppFirstDetails'
import AppSecondDetails from 'src/components/details/brand-details/AppSecondDetails'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// helpers
import Axios from 'src/helpers/axios'
import useToastMessage from 'src/helpers/toast-message'

const AppDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params
  const { showError } = useToastMessage();

  const [brandDetails, setBrandDetails] = useState('')
  const [brandImages, setBrandImages] = useState([])

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const handleCardHeaderButton = () => {
    navigate(`/products/brand/edit/${id}`);
    window.location.reload();
  }

  useEffect(() => {
    fetchBrandDetails()
  }, [id]);

  const fetchBrandDetails = () => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/brands/products/id/${id}`,
    })
      .then(({ data }) => {
        setBrandDetails(data)
        if (data.image_url && data.image_url !== '') {
          setBrandImages([data.image_url])
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const handleDeleteConfirmation = (item) => {
    Axios({
      method: "delete",
      url: `/api/ecommerce/v1/brands/products/delete/${item.id}`,
    })
      .then(({ data }) => {
        setShowConfirmDelete({ show: false, item: {} })
        navigate(`/products/brand/list`)
      })
      .catch((err) => {
        console.error(err);
        const message = err?.response?.data?.message?.replace(/-/g, " ").replace(err?.response?.data?.message.charAt(0), err?.response?.data?.message.charAt(0).toUpperCase())
        showError(message)
        setShowConfirmDelete({ show: false, item: {} })
      });
  }

  return (
    <AppCard
      className='mt-4 mb-4'
      headerTitle={
        <AppCardHeader
          id={id}
          headerTitle={<h4>Brand Details</h4>}
          headerButton="Edit"
          handleCardHeaderButton={handleCardHeaderButton}
          headerDeleteButton={true}
          setShowConfirmDelete={setShowConfirmDelete}
        />
      }
      bodyContent={
        <AppFirstDetails
          brandDetails={brandDetails}
          brandImages={brandImages}
        />
      }
      lowerBodyContent={
        <AppSecondDetails
          brandProducts={brandDetails?.products}
        />
      }
    />
  )
}

export default AppDetails
